import axios from "axios";
import { API_GET_TESTIMONIAL_DATA, API_INSERT_TESTIMONIAL_DATA, API_TOGGLE_TESTIMONIAL_DATA, API_UPDATE_TESTIMONIAL_DATA } from ".";

export const getTestimonialList = async (func, config) => {
    return axios.get(API_GET_TESTIMONIAL_DATA, config).then(res => func(res.data.data));
}

export const insertTestimonialData = async (data, config) => {
    return axios.post(API_INSERT_TESTIMONIAL_DATA, data, config).then((res) => res.data);
};

export const updateTestimonialData = async (data, config) => {
    return axios.put(API_UPDATE_TESTIMONIAL_DATA, data, config).then((res) => res.data);
};

export const toggleTestimonialData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_TESTIMONIAL_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};